import {MapContext} from "../pages/MapRenderer";
import {useContext} from "react";

import '../styles/LegendRenderer.css';

const LegendItem = ({ item }) => {
    return (
        <div className='LegendItem'>
            <p className="name">{item.name}</p>
            <div className="color" style={{ background: item.color }}/>
        </div>
    );
}

const LegendRenderer = () => {
    const { map, template } = useContext(MapContext);

    return (
        <div className='LegendRenderer'>
            {(map.legend ?? template.legend).map(item => <LegendItem key={item.id} item={item}/>)}
        </div>
    )
}

export default LegendRenderer;
